import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { ACHFromAccount, ACHToParticipant, Account, CompanyAccount, Participant } from "model";
import { useEffect } from "react";
export default function CaptureTemplateDetailsACHParticipantsAdded(props) {
  const context = useBCMSContext();
  const { branding } = context.state;
  BCMSRecord.globalControllerFor(Classes, context);
 let hasLOC = context.state.branding.options.loc_primary_abi22 == "true"; 
  BCMSRecord.globalControllerFor(Classes, context);
  let selectedAccount = hasLOC ? Account.initByID(10) :Account.initByID(5);
  const achFromAccount = ACHFromAccount.init({ account: selectedAccount.id, id: ACHFromAccount.nextID() });
  const defaultData = getDefaultData();

  let achToParticipants = defaultData.achToParticipants.participants;
  let nextID = undefined;
  if (achToParticipants.length === 0) {
    nextID = ACHToParticipant.nextID();
  } else {
    nextID = achToParticipants.length;
  }
  const participants = Participant.initAll().map(item => {
    // "isSelected" will be used to keep track of row selection.
    item.isSelected = "true";
    return item;
  }).filter(item => {
    return item.group === "Employee";
  });
  const updatedACHToParticipants = participants.reduce((acc, item) => {
    if (item.isSelected === "true") {
      const added = ACHToParticipant.init({
        id: nextID, participant: item.id,
        oneTimeACHPayment: defaultData.oneTimeACHPayment, notify: "No", addenda: "0", numberOfDistributions: "2"
      });
      nextID = parseFloat(nextID) + 1;
      acc.push(added);
    }
    return acc;
  }, []);

  achToParticipants = [...updatedACHToParticipants, ...achToParticipants];

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update(["template", "secCode"], "PPD Credit - Consumer Credit")
    .update(["template", "name"], "New Payroll")
    .update(["template", "companyDiscretionaryData"], "Bi-Weekly")
    .update(["template", "companyEntryDescription"], "Payroll")
    .update(["template", "companyAccount"], CompanyAccount.initByID(0))
    .update(["achFromAccounts", "accounts"], [achFromAccount])
    .update([ "selectedOffsetAccount", "account" ], selectedAccount)
    .update(["achToParticipants", "participants"], achToParticipants)
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showSecCode", "isActive"], true)
    .update(["showOneTimeACHModal", "isActive"], false)

    .submit();
 useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

  return (
    <TemplateDetailsPage ui={ui} data={data} />
  )
}
